import firebase from '@/scripts/firebase';

export default {
  async LOAD_DATA(context) {
    firebase.init();
    const data = firebase.loadData();
    const results = await Promise.all([data]);
    context.commit('SET_DATA', results[0]);
  },

  async SEND_FORM({ commit }, form) { // eslint-disable-line
    await fetch('/form/send.php', {
      method: 'POST',
      body: form,
    })
      .then(res => res.json())
      .then((json) => {
        if (json.response === 1) commit('FORM_STATUS', 'sent');
      });
  },
};
